import { render, staticRenderFns } from "./ProzessSearchInput.vue?vue&type=template&id=488a2974"
import script from "./ProzessSearchInput.vue?vue&type=script&lang=js"
export * from "./ProzessSearchInput.vue?vue&type=script&lang=js"
import style0 from "./ProzessSearchInput.vue?vue&type=style&index=0&id=488a2974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports